import type { ReactNode } from 'react';

// Tiny markdown renderer for job descriptions: # h2, ## h3, - list, plain paras.
export const Markdown = ({ source }: { source: string }) => {
  const lines = (source || '').split('\n');
  const out: ReactNode[] = [];
  let list: ReactNode[] = [];
  const flush = (k: string | number) => {
    if (list.length) {
      out.push(
        <ul
          key={'ul' + k}
          style={{
            margin: '4px 0 12px',
            paddingLeft: 18,
            display: 'flex',
            flexDirection: 'column',
            gap: 5,
          }}
        >
          {list}
        </ul>,
      );
      list = [];
    }
  };
  lines.forEach((ln, i) => {
    if (ln.startsWith('# ')) {
      flush(i);
      out.push(
        <h2
          key={i}
          style={{
            fontFamily: 'var(--hf-font-display)',
            fontSize: 19,
            fontWeight: 400,
            margin: '0 0 8px',
            letterSpacing: '-0.02em',
            color: 'var(--hf-ink)',
          }}
        >
          {ln.slice(2)}
        </h2>,
      );
    } else if (ln.startsWith('## ')) {
      flush(i);
      out.push(
        <h3
          key={i}
          style={{
            fontSize: 11,
            fontWeight: 500,
            textTransform: 'uppercase',
            letterSpacing: '0.1em',
            color: 'var(--hf-ink-3)',
            margin: '14px 0 4px',
          }}
        >
          {ln.slice(3)}
        </h3>,
      );
    } else if (ln.startsWith('- ')) {
      list.push(
        <li key={i} style={{ fontSize: 13, color: 'var(--hf-ink-2)', lineHeight: 1.5 }}>
          {ln.slice(2)}
        </li>,
      );
    } else if (ln.trim() === '') {
      flush(i);
    } else {
      flush(i);
      out.push(
        <p
          key={i}
          style={{ fontSize: 13, color: 'var(--hf-ink-2)', lineHeight: 1.6, margin: '0 0 10px' }}
        >
          {ln}
        </p>,
      );
    }
  });
  flush('end');
  return <>{out}</>;
};
